import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSpinnerComponent } from 'ngx-spinner';

import { FontAwesomeIconRegistryService } from './font-awesome-icon-registry.service';

@Component({
  imports: [RouterModule, FontAwesomeModule, NgxSpinnerComponent],
  selector: 'app-root',
  template: `
    <ngx-spinner type="ball-scale-multiple">
      <p class="loading">Loading...</p>
    </ngx-spinner>
    <router-outlet></router-outlet>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FontAwesomeIconRegistryService]
})
export class AppComponent {
  public constructor(private fontAwesomeIconRegistryService: FontAwesomeIconRegistryService) {
    this.fontAwesomeIconRegistryService.init();
  }
}
